import React from "react";
import tw from "tailwind-styled-components";
import { IoIosArrowForward } from "react-icons/io";
import { useNavigate } from "react-router-dom";

function KPIs({ data, setIsShowAnalytics }) {
  const navigate = useNavigate();
  // Normalize fields from API response
  const summary = {
    totalComplaints: data?.total ?? 0,
    unassigned: data?.unassigned ?? 0,
    assigned: data?.assigned ?? 0,
    resolved: data?.resolved ?? 0,
    reopened: data?.reopened ?? 0,
    avgResolutionTime: data?.avgResolutionHours
      ? `${Number(data.avgResolutionHours).toFixed(1)} hrs`
      : "0 hrs",
  };

  const metrics = [
    {
      label: "Total Complaints",
      value: summary.totalComplaints,
      link: "/complaints",
      color: "text-slate-800",
    },
    {
      label: "Unassigned",
      value: summary.unassigned,
      link: "/complaints",
      color: "text-rose-600",
    },
    {
      label: "Assigned",
      value: summary.assigned,
      link: "/complaints",
      color: "text-blue-600",
    },
    {
      label: "Resolved",
      value: summary.resolved,
      link: "/complaints",
      color: "text-emerald-600",
    },
    {
      label: "Reopened",
      value: summary.reopened,
      link: "/complaints",
      color: "text-violet-600",
    },
    {
      label: "Avg. Resolution",
      value: summary.avgResolutionTime,
      link: "/complaints",
      color: "text-cyan-700",
    },
  ];

  return (
    <Container>
      <HeaderRow>
        <MetricsRow>
          <MetricsScroll>
            {metrics.map((item) => (
              <Metric key={item.label} onClick={() => navigate(item.link)}>
                <MetricLabel>{item.label}</MetricLabel>

                <MetricValue className={item.color}>
                  {item.value ?? 0}
                  <Arrow />
                </MetricValue>
              </Metric>
            ))}
          </MetricsScroll>
        </MetricsRow>

        {/* {canViewFinance && (
          <ArrowStatic onClick={() => setIsShowAnalytics?.(true)}>→</ArrowStatic>
        )} */}
      </HeaderRow>
    </Container>
  );
}

const Container = tw.div`
  mt-2 md:mt-6
  bg-white rounded-lg shadow-sm
  px-4 py-4 md:px-6
`;

const HeaderRow = tw.div`
  flex items-start justify-between
  w-full
`;

const MetricsScroll = tw.div`
  flex gap-4
  overflow-x-auto
  scrollbar-hide
  pb-1
  grid md:grid-cols-6 xl:grid-cols-6 grid-cols-3
`;

const Metric = tw.div`
  min-w-[110px]
  flex-shrink-0
  cursor-pointer
  group
`;

const MetricLabel = tw.div`
  text-[9px] md:text-[11px]
  uppercase tracking-wide
  text-gray-500
  whitespace-nowrap
`;

const MetricValue = tw.div`
  flex items-center gap-1
  text-lg font-semibold
  transition-colors
`;

const Arrow = tw(IoIosArrowForward)`
  text-gray-400 text-xs
  opacity-0 group-hover:opacity-100
  transition-opacity
`;

const MetricsRow = tw.div`
  flex-1 min-w-0
`;

const ArrowStatic = tw.span`
  text-gray-400 text-lg
  cursor-pointer
  hover:text-gray-600
  transition
  ml-4 flex-shrink-0
  self-start
`;

export default KPIs;